// @mui material components
import { Check, TableBar } from "@mui/icons-material";
import Tooltip from "@mui/material/Tooltip";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

function TableStatusCell({ closedAt }) {
  const open = (
    <SoftBox display="flex" alignItems="center">
      <SoftTypography variant="body1" color="success" sx={{ lineHeight: 0 }}>
        <Tooltip title="CLOSED" placement="top">
          <Check />
        </Tooltip>
      </SoftTypography>
    </SoftBox>
  );

  const closed = (
    <SoftBox display="flex" alignItems="center">
      <SoftTypography variant="body1" color="error" sx={{ lineHeight: 0 }}>
        <Tooltip title="OPEN" placement="top">
          <TableBar />
        </Tooltip>
      </SoftTypography>
    </SoftBox>
  );

  if (closedAt === null) return closed;
  return open;
}

export default TableStatusCell;
